import { Button, Field } from 'click-controls';
import { action, computed, observable } from 'mobx';

import history from 'bz-utilities/modules/networking/history/rr4';
import cx from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router-dom';
import z from 'z';
import HelpStore from './Store/help-store';
import Snackbar from './snackbar';

interface IProps {}
@observer
class Help extends React.Component<IProps> {
  static emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  static emailErrorText = 'The Email provided is invalid';
  @observable snackOpen = false;
  @observable email = '';
  store = new HelpStore();
  @observable error = '';
  @observable submitted = false;

  @action.bound
  validateEmail(): boolean {
    if (!Help.emailRegex.test(this.email)) {
      this.error = Help.emailErrorText;
      this.submitted = true;
      return false;
    } else {
      this.error = '';
      this.submitted = false;
      return true;
    }
  }

  async resetPassword(e: React.ChangeEvent<HTMLFormElement>) {
    e.preventDefault();
    if (this.error) return;
    const potentialSuccess = await this.store.resetPassword(this.email);
    if (potentialSuccess) this.emailSentNotice();
  }

  emailSentNotice() {
    return history.push('login/help/sent');
  }

  @action.bound
  emailChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.email = e.target.value;
  }

  @action.bound
  closeSnack() {
    this.snackOpen = false;
  }

  @computed
  get canClick(): boolean {
    return this.email !== '';
  }

  render() {
    return (
      <form id="form-login" className="grid" role="form" onSubmit={this.resetPassword.bind(this)}>
        <h3 className="mb-4 text-3xl font-bold">Forgotten your password?</h3>
        <p className="mb-12 text-base">Let's get you logged back in.</p>
        <Snackbar open={this.snackOpen} onClick={this.resetPassword} onClose={this.closeSnack} />
        <Field
          type="email"
          label="Email Address"
          placeholder="abc@example.com"
          onChange={this.emailChange}
          onBlur={this.validateEmail}
          errored={!!this.error}
          errorText={this.error}
          submitted={this.submitted}
          required={true}
          liveOnChange={true}
        />

        <Button className={cx('btn mt-2')} onClick={this.resetPassword.bind(this)}>
          Reset Password
        </Button>
        {this.store.error && (
          <div className="my-4 block rounded-md border border-rose-300 bg-rose-100 p-3 text-center text-sm text-rose-600">
            <p>There was a problem resetting your password, please contact your IT Support Team.</p>
            <p>
              This may be because the user or email doesn't exist or the account is setup to use a
              PassKey. It is not possible to reset passwords for PassKey accounts.
            </p>
            <p className="mt-2">
              If you have lost your PassKey device or token, please contact your {z.word('TM3')}{' '}
              Administrator, or our technical support team, so that they can verify your identity
              and reset the PassKey on your {z.word('TM3')} account.
            </p>
          </div>
        )}
        {
          <p className="mt-4">
            <Link to="/login" className="text-info mt-10 text-sm">
              Back to Login
            </Link>
          </p>
        }
      </form>
    );
  }
}

export default Help;
